module.exports = __webpack_public_path__ + "static/media/img_58.d8945685.png";